import { adminHttpClient } from "../commons/adminHttpClient";

const getNewsTickerAuditReportExcel = (id: string): Promise<any> => {
  return adminHttpClient.get(`/NewsTickerAudits/View/GenerateExcel/${id}`);
};

export default getNewsTickerAuditReportExcel;